export default __webpack_public_path__ + "static/time-06bba3b474cd715fbfc4cccc6987b73b.png";